import React from "react";
import axios from "axios";
import Spinner from "../../components/Spinner";
import { Modal } from "../../components/Modal";
import OtpInput from "../../components/OtpInput";

const API = localStorage.getItem("assethost");

export default class ChangeOwnershipFinalise extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      msg: "",
      toastColor: "",
      assetId: "",
      assetDetails: null,

      // OTP form fields
      otpCode: "",
      assetNumber: "",
      showOtpInput: true,
      errors: {},
      valid: true,
    };
    this.handleFinalise = this.handleFinalise.bind(this);
    this.validate = this.validate.bind(this);
    this.loadAssetDetails = this.loadAssetDetails.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    // const urlParams = new URLSearchParams(window.location.search);
    // let assetId = urlParams.get("assetId");
    // if (!assetId) {
    //   assetId = this.props.assetId;
    // }
    // if (assetId) {
    //   this.setState({ assetId }, this.loadAssetDetails);
    // } else {
    //   this.setState({
    //     msg: "No asset ID provided",
    //     toastColor: "danger",
    //   });
    // }
  }

  loadAssetDetails() {
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        loading: false,
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.location.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }

    this.setState({ loading: true });
    axios
      .get(API + `/asset/getchangeofownershipview/${this.state.assetId}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        this.setState({
          assetDetails: response.data,
          loading: false,
          showOtpInput: true,
        });
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.location.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          loading: false,
          msg:
            error?.response?.data?.message || "Failed to load asset details.",
          toastColor: "danger",
        });
      });
  }

  handleOtpComplete = (otpCode) => {
    this.setState({ otpCode }, this.validate);
  };

  handleOtpReset = (otpCode) => {
    this.setState({ otpCode });
  };

  handleChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value }, this.validate);
  }

  validate() {
    const s = this.state;
    let errors = {};
    let valid = true;

    if (!s.otpCode || s.otpCode.length !== 5) {
      errors.otpCode = "Please enter a valid 5-digit OTP code";
      valid = false;
    }
    if (!s.assetNumber || !s.assetNumber.trim()) {
      errors.assetNumber = "Asset number is required";
      valid = false;
    }

    this.setState({ errors, valid });
    return valid;
  }

  handleFinalise(e) {
    e.preventDefault();
    if (!this.validate()) {
      this.setState({
        msg: "Please enter a valid OTP code.",
        toastColor: "danger",
      });
      return;
    }

    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.location.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }

    this.setState({ loading: true, msg: "", toastColor: "" });

    let request = {
      assetNumber: this.state.assetNumber,
      otpCode: this.state.otpCode,
    };

    if (Number(sessionStorage.getItem("companyProfileId"))) {
    request.companyProfileId =   sessionStorage.getItem("companyProfileId");
    }
    if (Number(sessionStorage.getItem("individualProfileId"))) {
     request.individualProfileId =  sessionStorage.getItem("individualProfileId");
    }

    axios
      .post(API + "/asset/changeofownershipfinalise", request, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        if (response.data.success) {
          this.setState({
            msg:
              response.data.message ||
              "Ownership transfer completed successfully!",
            toastColor: "success",
            loading: false,
          });
          setTimeout(() => {
            this.props.closeAction();
            if (this.props.onSuccess) {
              this.props.onSuccess();
            }
          }, 3000);
        } else {
          this.setState({
            msg:
              response.data.message || "Failed to complete ownership transfer",
            toastColor: "danger",
            loading: false,
          });
        }
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.location.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          msg:
            error?.response?.data?.message ||
            "Failed to complete ownership transfer. Please try again.",
          toastColor: "danger",
          loading: false,
        });
      });
  }

  render() {
    const s = this.state;
    let divMsg = null;
    if (s.msg) {
      divMsg = (
        <div
          className={
            s.toastColor === "success"
              ? "alert alert-success mx-7"
              : "alert alert-danger mx-7"
          }
        >
          {s.msg}
        </div>
      );
    }

    if (s.loading && !s.assetDetails) {
      return (
        <Modal title="Complete Ownership Transfer" footerContent={<></>}>
          <div className="w-100 h-10 overflow-hidden d-flex justify-content-center align-items-center">
            <Spinner className="" />
          </div>
        </Modal>
      );
    }

    return (
      <Modal
        title="Complete Ownership Transfer"
        closeAction={this.props.closeAction}
        footerContent={
          <>
            {s.valid && s.otpCode && s.otpCode.length === 5 && (
              <button
                type="button"
                className="btn btn-primary"
                disabled={!s.valid || s.loading}
                onClick={this.handleFinalise}
              >
                {s.loading ? "Processing..." : "Finalise"}
              </button>
            )}
            <button
              type="button"
              className="btn btn-primary"
              onClick={this.props.closeAction}
            >
              Close
            </button>
          </>
        }
      >
        {divMsg}

        {s.assetDetails && (
          <div className="mb-4">
            <div className="row">
              <div className="col">
                <b>Asset Number: </b>
                <span>{s.assetDetails.assetNumber}</span>
              </div>
              <div className="col">
                <b>Category: </b>
                <span>{s.assetDetails.categoryName}</span>
              </div>
            </div>
            <div className="row">
              <div className="col">
                <b>Sub Category: </b>
                <span>{s.assetDetails.subcategoryName}</span>
              </div>
              <div className="col">
                <b>Unique Identifier: </b>
                <span>{s.assetDetails.uniqueIdentifier}</span>
              </div>
            </div>
            <div className="row">
              <div className="col">
                <b>Status: </b>
                <span>{s.assetDetails.primaryStatus}</span>
              </div>
              <div className="col">
                <b>Current Owner: </b>
                <span>{s.assetDetails.ownerMobileNumber}</span>
              </div>
            </div>
          </div>
        )}

        {s.showOtpInput && (
          <form
            className="d-flex flex-column w-100"
            autoComplete="off"
            onSubmit={this.handleFinalise}
          >
            <div className="row">
              <div className="col">
                <div className="input-group">
                  <label className="input-group-text">Asset Number</label>
                  <input
                    name="assetNumber"
                    className={`form-control ${
                      s.errors.assetNumber ? " !border-red-500" : ""
                    }`}
                    value={s.assetNumber}
                    onChange={this.handleChange}
                    autoFocus={true}
                    required
                  />
                  {s.errors.assetNumber && (
                    <span className="input-group-error">
                      {s.errors.assetNumber}
                    </span>
                  )}
                </div>
              </div>
              <div className="col">
                <div className="input-group">
                  <label className="input-group-text">Enter OTP Code</label>
                  <OtpInput
                    length={5}
                    onComplete={this.handleOtpComplete}
                    onReset={this.handleOtpReset}
                    autofocus={false}
                  />
                  {s.errors.otpCode && (
                    <span className="text-red-500 text-sm mt-1">
                      {s.errors.otpCode}
                    </span>
                  )}
                </div>
              </div>
            </div>

            <div className="text-sm text-muted mb-4">
              Enter the asset number and 5-digit OTP code from the seller to
              complete the ownership transfer.
            </div>
          </form>
        )}
      </Modal>
    );
  }
}
